import { Checkbox, MenuItem, MenuItemProps, Box } from '@mui/material'

type MenuItemWithCheckboxProps = MenuItemProps

const MenuItemWithCheckbox: React.FC<
  React.PropsWithChildren<MenuItemWithCheckboxProps>
> = ({ children, ...props }) => {
  return (
    <MenuItem {...props}>
      <Checkbox checked={!!props.selected} edge="start" size="small" />
      <Box
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {children}
      </Box>
    </MenuItem>
  )
}

export default MenuItemWithCheckbox
